import React from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';

const OutletClose = ({ open, onClose }) => {
  return (
    <BottomSheet open={open} onDismiss={onClose} id="outlet-close">
      <div className="px-4">
        <h3 className="text-sm font-semibold text-gray-900 w-3/4 mb-2">
          Toko sedang tutup
        </h3>

        <h6 className="text-xs font-normal text-gray-700 w-3/4">
          Saat ini restoran tidak melayani pesanan. Silakan kembali lagi nanti ya.
        </h6>

        <button
          onClick={onClose}
          className="w-full button text-sm font-semibold"
          style={{ marginTop: '32px', marginBottom: '26px' }}
        >
          Mengerti
        </button>
      </div>
    </BottomSheet>
  );
};

export default OutletClose;